import React, {useState, useEffect, useRef}  from 'react';
import { useDispatch, useSelector } from "react-redux";
import Layout from "../../layout/Layout";
import moment from 'moment';

import { useropen } from '../../redux/userInfo';
import { open, close } from '../../redux/popupSlice';
import { Link, useNavigate } from 'react-router-dom';

import Input from '../../component/Input';
import Button from '../../component/Button';
import Profiles from '../../component/Profiles';
import MypageleftArea from '../../component/MypageleftArea';


import * as APIS from "../../utils/service";
import { getMemberinfo, regPhone, patternPwCker, useIntersectionObserver, numFormat } from "../../utils/utils";



export default function Blacklists({ navigation }) {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const [memberinfos, setmemberinfos] = useState(''); 
    const [myblacklist, setmyblacklist] = useState([]); 

    useEffect(() => {
        getMemberinfo(setmemberinfos);
    }, []);

    useEffect(() => {
        getlist();
    }, [memberinfos]);
    const getlist = () => {
        setmyblacklist(memberinfos?.myblacks);
    }

    return(
        <Layout header={false} actives={''}>
            <div className='mypagearea'>
                <div >
                    <MypageleftArea pages={0} />
                </div>
                <div className='padding32'>
                    <div className='pagetitle fontsize20 bolds'>개인설정</div>
                    <div className='pagetabs margint20'>
                        <button onClick={() => { navigate('/Mypage') }}>내정보</button>
                        <button onClick={() => { navigate('/Favoritpage') }}>즐겨찾기</button>
                        <button className='active' onClick={() => { navigate('/Blacklists') }}>블랙리스트</button>
                    </div>
                    <div className='mypageinputsarea'>
                        <div className='favoritArea'>
                            {myblacklist?.map((x, i) => {
                                x.targetUser.blackflas = true;
                                return (
                                    <div><Profiles memberinfosData={x?.targetUser} favblackData={x} blackremove={true} companyinfos={x?.targetUser?.compony} /></div>
                                );
                            })}
                        </div>
                        {myblacklist?.length === 0 &&
                            <div className='nolistArea'>
                                블랙리스트가 없습니다.
                            </div>
                        }
                    </div>
                </div>
            </div>
        </Layout>
    )
}

